var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row-fluid align-items-end",
      staticStyle: { "transition-delay": "0s" }
    },
    [
      _c("h4", { staticClass: "mt-0" }, [_vm._v("Change Password")]),
      _vm._v(" "),
      _c("section", { staticClass: "bg-white mb-0" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "currentPassword" } }, [
            _vm._v("Current Password:")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.currentPassword,
                expression: "form.currentPassword"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "password", id: "currentPassword", required: "" },
            domProps: { value: _vm.form.currentPassword },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "currentPassword", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "newPassword1" } }, [
            _vm._v("New Password:")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.newPassword1,
                expression: "form.newPassword1"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "password", id: "newPassword1", required: "" },
            domProps: { value: _vm.form.newPassword1 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "newPassword1", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "newPassword2" } }, [
            _vm._v("Confirm New Password:")
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.newPassword2,
                expression: "form.newPassword2"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "password", id: "newPassword2", required: "" },
            domProps: { value: _vm.form.newPassword2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "newPassword2", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary mt-3 col",
            attrs: { type: "submit" },
            on: { click: _vm.changePassword }
          },
          [_vm._v("Change Password")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary col mt-4 bg-light",
            attrs: { type: "reset" },
            on: { click: _vm.reset }
          },
          [_vm._v("Cancel")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-499d154b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-499d154b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Password.vue
// module id = null
// module chunks = 